
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const expertiseData = [
  {
    id: "01",
    title: "Dereja.com",
    description: [
      "Central access point for job listings, internships, and career resources",
      "Hosts verified employer profiles and curated opportunities",
      "Offers digital learning content and Telegram job alerts",
      "Continuously updated with sector-specific openings and training info",
    ],
    image: "/assets/website.png",
  },
  {
    id: "02",
    title: "Training & Capacity Building",
    description: [
      "Soft skills and career readiness support for graduating students",
      "Practical employability workshops focused on job search fundamentals",
      "Career orientation for first-year university entrants",
      "Digital literacy programs enhancing online professionalism",
      "Targeted technical training aligned with labor market needs",
    ],
    image: "/assets/tot.png",
  },
  {
    id: "03",
    title: "Job Fairs & Career Expos",
    description: [
      "Regional and national job fairs connecting youth and recruiters",
      "On-site interviews, CV clinics, and hiring pipelines",
      "Milk-run model to boost employer attendance in underserved regions",
    ],
    image: "/assets/img11.jpg",
  },
  {
    id: "04",
    title: "Employer Linkage & Capability Program",
    description: [
      "Focused on equipping HR teams and business leaders to integrate young talent through structured internships and trainee pathways.",
      "Designed as a pilot to address youth unemployment from both the graduate and employer perspectives.",
      "Organize annual conferences and workshops to strengthen collaboration between higher education institutions and industry partners",
    ],
    image: "/assets/employerpool.jpg",
  },
  {
    id: "05",
    title: "Entrepreneurship & Innovation",
    description: [
      "Connects students to incubation centers and startup networks",
      "Provides mentorship, funding, and technical assistance",
      "Showcases university alumni driving businesses and ventures",
      "Facilitates access to startup resources and workshops to foster entrepreneurial skills."
    ],
    image: "/assets/innovative.png",
  },
  {
    id: "06",
    title: "Dereja Alumni Network",
    description: [
      "Community connecting university graduates to share experiences, collaborate professionally, and support current students.",
      "Fostering meaningful relationships and providing resources like mentorship and networking opportunities DAN enhances personal and professional growth while strengthening the legacy of its institutions.",
      "Through digital engagement,DAN ensures that alumni remain connected, contributing to the ongoing success and reputation of their alma maters."
    
    ],
    image: "/assets/AAUuniversity.jpg",
  },
  {
    id: "07",
    title: "Youth Advisory Group (YAG)",
    description: [
      "Ensures youth voices shape program design and delivery.",
      "It strengthens relevance, boosts engagement, and taps into young people’s creativity resulting in more inclusive, responsive, and impactful solutions.",
      "Involving youth drives ownership and fosters resilient communities.",
    ],
    image: "/assets/YAG.jpg",
  },
   {
    id: "08",
    title: "Instructor Seminar: Empowering Career Development",
    description: [
      "Raise awareness of the importance of career paths for graduates.",
      "Highlight instructors' roles in fostering employability skills.",
      "Align teaching practices with labor market demands.",
      "Share best practices and resources for effective career guidance.",
    ],
    image: "/assets/seminar.webp",
  },

   {
    id: "09",
    title: "Career Club",
    description: [
      "Help students to identify their strengths and align them with career opportunities.",
      "Provides guidance throughout the career exploration process, from initial goal setting to job searching.",
      "The club actively engages students in their career development, collaborates with career development centers, and fosters a culture of professionalism.",
      "Empowers students through essential skills training and academic support for a successful transition into the workforce.",
    ],
    image: "/assets/images.jpg",
  },
];

export default function App() {
  const images = [
    "/assets/brightfuture.jpg",
    "/assets/NCE1.jpg",
    "/assets/NCE2.jpg",
    "/assets/NCE3.jpg",
    "/assets/NCE4.jpg",
  ];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="font-sans text-gray-900">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center px-4 bg-white overflow-hidden">
        <motion.img
          key={images[currentImageIndex]}
          src={images[currentImageIndex]}
          alt="Bright Future"
          initial={{ opacity: 0.3, scale: 1.1, filter: "blur(1px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          className="absolute inset-0 w-full h-full object-cover brightness-10 contrast-105 z-0"
        />
        <div className="absolute inset-0 bg-white/50 z-0" />
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 w-full px-6 text-black text-center md:text-left">
          <div className="md:w-1/2">
            <h1 className="text-3xl md:text-4xl font-bold mb-2 drop-shadow-sm">
              Building a Brighter Future
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold mb-2">
              Empowering Ethiopia’s Workforce
              <br />
              <span className="text-orange-500">Through Dereja’s Vision</span>
            </h2>
          </div>
        </div>
      </section>

      
      <section className="bg-gray-100 text-white py-8 px-6 md:px-16">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-orange-400 mb-3">
            Tailored Solutions For Your Employment Needs
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            Whether you're a fresh graduate seeking your first job or an
            employer looking for the right talent, Dereja offers personalized
            support to match your goals. Our solutions are flexible, impactful,
            and designed just for you.
          </p>
        </div>
      </section>

      {/* Intervention Areas */}
      <section className="bg-white text-black py-10 px-6 md:px-16">
        <motion.h3
          initial={{ opacity: 0, scale: 0.8, filter: "blur(4px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 2, ease: "easeOut" }}
          className="text-2xl font-bold text-center mb-10 text-orange drop-shadow-lg"
        >
          Program Intervention Areas
        </motion.h3>

        {/* Main Interventions */}
        <h4 className="text-2xl font-bold mb-6 text-orange">
          Our Core Interventions
        </h4>
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {expertiseData.slice(0, 3).map((item, index) => (
            <motion.div
              key={item.id}
              className="w-[270px] bg-white border-l-4 border-orange-500 shadow-md rounded overflow-hidden"
              initial={{ opacity: 0, y: 50, filter: "blur(8px)" }}
              whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03 }}
whileTap={{ scale: 0.97 }}

            >
              <img
                src={item.image}
                alt={item.title}
                className="h-28 w-full object-cover"
              />
              <div className="p-3">
                <p className="text-xs font-semibold text-orange-600">
                  {item.id}
                </p>
                <h4 className="font-bold text-base mb-1">{item.title}</h4>
                <ul className="list-disc pl-4 text-xs text-gray-600">
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

       
        <h4 className="text-2xl font-bold mb-6 text-orange">
          Expansion of Our Interventions
        </h4>
        <div className="flex flex-wrap justify-center gap-6">
          {expertiseData.slice(3).map((item, index) => (
            <motion.div
              key={item.id}
              className="w-[270px] bg-white border-l-4 border-orange-400 shadow-md rounded overflow-hidden"
              initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
              whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03 }}
whileTap={{ scale: 0.97 }}

            >
              <img
                src={item.image}
                alt={item.title}
                className="h-28 w-full object-cover"
              />
              <div className="p-3">
                <p className="text-xs font-semibold text-orange-500">
                  {item.id}
                </p>
                <h4 className="font-bold text-base mb-1">{item.title}</h4>
                <ul className="list-disc pl-4 text-xs text-gray-600">
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}


